import { MarketplaceAPI } from 'api/build/marketplaceAPI';

export * from 'api/build/marketplaceAPI';
// eslint-disable-next-line
export default new MarketplaceAPI();
